import { post } from "./utils";

export const postMessageReply = async (
  formId: string,
  messageId: number,
  reply: string
) => await post("form-status/" + formId + "/reply/" + messageId, { reply });
